import angular from 'angular';
import constants from 'app/constants';
import IComplianceAppDataService from './IComplianceApp.data.service';
import orgDataService from './org.data.service';

let _orgDataService;
let _$q;

class emDataService extends IComplianceAppDataService {
  constructor(
    $http,
    utilityService, // eslint-disable-line no-shadow
    $q,
    orgDataService, // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'em');
    _$q = $q;
    _orgDataService = orgDataService;
    console.log('app.services.emDataService created');
  }

  // #################################################################################################
  // DEPARTMENTS

  getDepartments() {
    return this.$http({
      url: `${this.apiRootUrl}/em/department`,
      method: 'GET',
    });
  }

  getDepartment(departmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/department/${departmentId}`,
      method: 'GET',
    });
  }

  getDefaultDepartment() {
    return this.$http({
      url: `${this.apiRootUrl}/em/department/default`,
      method: 'GET',
    });
  }

  checkDepartmentExists(departmentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/em/department/checkExists/`,
      method: 'GET',
      params: {
        id: departmentId,
        name,
      },
    });
  }

  saveDepartment(departmentId, name, departmentOwnerUserIds, departmentTeamMemberUserIds, customerId) {
    const data = {
      departmentId,
      name,
      customerId,
      departmentOwnerUserIds: JSON.stringify(departmentOwnerUserIds),
      departmentTeamMemberUserIds: JSON.stringify(departmentTeamMemberUserIds),
    };

    if (departmentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/em/department/${departmentId}`,
        method: 'PUT',
        data: this.serializeData(data),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/em/department`,
      method: 'POST',
      data: this.serializeData(data),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteDepartment(departmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/department/${departmentId}`,
      method: 'DELETE',
    });
  }

  // #################################################################################################
  // PROCESSES

  getProcesses(departmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/${departmentId}/process`,
      method: 'GET',
    });
  }

  getProcess(processId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/process/${processId}`,
      method: 'GET',
    });
  }

  checkProcessExists(departmentId, processId, name) {
    console.log(departmentId, processId, name);
    return this.$http({
      url: `${this.apiRootUrl}/em/process/checkExists`,
      method: 'GET',
      params: {
        departmentId,
        id: processId,
        name,
      },
    });
  }

  saveProcess(departmentId, processId, name, successions) {
    const successionPlanning = [];
    const transform = successor => ({
      processSuccessionPlanId: successor.processSuccessionPlanId,
      processId,
      vendorId: successor.vendorId,
      vendorName: successor.isVendor ? successor.name : '',
      planPriority: successor.planPriority,
      userId: successor.userId,
      userName: !successor.isVendor ? successor.name : '',
    });

    if (successions.primary !== null) {
      successionPlanning.push(transform(successions.primary));
    }
    if (successions.alternate !== null) {
      successionPlanning.push(transform(successions.alternate));
    }
    if (successions.tertiary !== null) {
      successionPlanning.push(transform(successions.tertiary));
    }

    if (processId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/em/process/${processId}`,
        method: 'PUT',
        data: JSON.stringify({
          departmentId,
          processId,
          name,
          successionPlanning,
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/em/process`,
      method: 'POST',
      data: JSON.stringify({
        departmentId,
        processId,
        name,
        successionPlanning,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteProcess(processId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/process/${processId}`,
      method: 'DELETE',
    });
  }

  getSuccessorOptions(processId, processSuccessionPlanId) {
    const promises = [
      _orgDataService.getSelectableUsers(),
      this.getVendorResources(processId),
    ];
    return _$q.all(promises).then((results) => {
      const users = results[0].data.result;
      let vendorResources = [];
      if (processId > 0) {
        vendorResources = results[1].data.result;
      }
      if (!processSuccessionPlanId) {
        processSuccessionPlanId = 0;
      }
      const vendorOptions = this.transformVendorResourceToSuccessor(
        processId,
        processSuccessionPlanId,
        vendorResources
      );
      const userOptions = this.transformUsersToSuccessors(
        processId,
        processSuccessionPlanId,
        users
      );
      const successors = vendorOptions.concat(userOptions);
      return this.sortByName(successors);
    });
  }

  getVendorResources(processId) {
    if (processId <= 0) {
      const deferred = _$q.defer();
      deferred.resolve([]);
      return deferred.promise;
    }
    return this.$http({
      url: `${this.apiRootUrl}/em/process/${processId}/vendors`,
      method: 'GET',
    });
  }

  transformVendorResourceToSuccessor(processId, processSuccessionPlanId, vendorResources) {
    /**
     * @param {Object} vendor
     * @return {successor}
     */
    const transform = vendorResource => ({
      processId,
      processSuccessionPlanId,
      isVendor: true,
      name: vendorResource.name,
      planPriority: null,
      userId: null,
      vendorId: vendorResource.vendorId,
    });
    const successors = [];
    vendorResources.forEach(vR => successors.push(transform(vR)));
    return successors;
  }


  transformUsersToSuccessors(processId, processSuccessionPlanId, users) {
    /**
     * @param {Object} user
     * @return {successor}
     */
    const transform = user => ({
      processId,
      processSuccessionPlanId,
      isVendor: false,
      name: user.displayName,
      planPriority: null,
      userId: user.userId,
      functionVendorId: null,
    });
    const successors = [];
    users.forEach(u => successors.push(transform(u)));
    return successors;
  }

  // #################################################################################################
  // FUNCTIONS

  getFunctions(processId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function/byProcess`,
      method: 'GET',
      params: {
        processId,
      },
    });
  }

  getFunction(functionId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function/${functionId}`,
      method: 'GET',
    });
  }

  checkFunctionExists(processId, functionId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function/checkExists`,
      method: 'GET',
      params: {
        processId,
        id: functionId,
        name,
      },
    });
  }

  addFunction(functionObj) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function`,
      method: 'POST',
      data: this.serializeData(functionObj),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateFunction(functionObj) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function/${functionObj.functionId}`,
      method: 'PUT',
      data: this.serializeData(functionObj),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteFunction(functionId) {
    return this.$http({
      url: `${this.apiRootUrl}/em/function/${functionId}`,
      method: 'DELETE',
    });
  }

  /**
   * vendors
   */

  updateVendor(functionVendorId, vendor) {
    if (vendor.vendorId === -1) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/vendor`,
        method: 'POST',
        data: this.serializeData(vendor),
        params: {
          echo: true
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    if (!vendor.functionVendorId) {
      return this.$http({
        url: `${this.apiRootUrl}/vm/vendor/${vendor.vendorId}`,
        method: 'PUT',
        data: this.serializeData(vendor),
        params: {
          echo: true
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/em/functionVendor/${functionVendorId}`,
      method: 'PUT',
      data: JSON.stringify(vendor),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  sortByName(collection) {
    return this.sort(collection, 'name');
  }

  /**
   * Takes a collection of objects and sorts them by given property
   * @param {Array<Object>} collection
   * @returns {Array<Object>}
   */
  sort(collection, key) {
    return collection.sort((a, b) => {
      const aValue = this._getSortableValue(a, key);
      const bValue = this._getSortableValue(b, key);
      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
  }

  _getSortableValue(obj, key) {
    return typeof obj[key] === 'string' ? obj[key].toLowerCase() : obj[key];
  }

  hasIncompleteAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/em/hasIncomplete`,
      method: 'GET',
    });
  }
}

emDataService.$inject = [
  '$http',
  'utilityService',
  '$q',
  'orgDataService'
];

export default angular.module('app.services.emDataService', [
  constants,
  orgDataService,
])
  .service('emDataService', emDataService)
  .name;
